<template>
  <section class="content">
    <box>
      <div slot="body">
        <form-wizard @on-complete="onComplete" shape="square" color="#20a0ff" error-color="#ff4949"
          title="Cadastro nova campanha" subtitle="Avance pelas guias para finalizar o cadastro">

          <!-- TAB DE TIPO DA CAMPANHA -->
          <tab-content title="Tipo de Camapnha" icon="fa fa-info" :before-change="validateFirstStep">
            <el-form style="margin-top: 5%; margin-bottom: 5%">
              <div class="row">
                <!-- <div class="col-sm-6">
                  <span :class="['infoBox', gameColor]" @click="selecionarCard('game')">
                    <i :class="`fa fa-gamepad icon${gameColor}`"></i>
                    <h3 :class="`lblCard lbl${gameColor}`">Gameficação / Raspadinha </h3>
                  </span>
                </div> -->
                <div class="col-sm-6 col-sm-offset-3">
                  <span :class="['infoBox', ticketColor]" @click="selecionarCard('ticket')">
                    <i :class="`fa fa-ticket icon${ticketColor}`"></i>
                    <h3 :class="`lblCard lbl${ticketColor}`">Cupom de desconto</h3>
                  </span>
                </div>
              </div>
            </el-form>
          </tab-content>

          <!-- TAB DE DADOS DA CAMPANHA -->
          <tab-content title="Dados da Campanha" icon="fa fa-list-alt">
            <div class="row">
              <div class="col-sm-4">
                <h4>Código do cupom</h4>
                <input v-model="codigo" type="text" class="form-control">
                <label v-if="codigo===''">*Campo Obrigatório</label>
              </div>
              <div class="col-sm-4">
                <h4>Quantidade de cupons</h4>
                <input v-model="qtde_cupom" type="number" class="form-control">
                <label v-if="qtde_cupom===0">*Campo Obrigatório</label>
              </div>
              <div class="col-sm-4">
                <h4>Validade</h4>
                <input v-model="validade" type="datetime-local" class="form-control">
                <label v-if="!validade">*Campo Obrigatório</label>
              </div>
            </div><br>
            <div class="row">
              <div class="col-sm-4">
                <h4>Tipo do Cupom</h4>
                <label class="radio-inline"><input type="radio" name="radioTipoDesc" v-model="tipo_desc" value="frete" >Frete Grátis</label><br>
                <label class="radio-inline"><input type="radio" name="radioTipoDesc" v-model="tipo_desc" value="porcentagem" >Porcentagem de desconto</label><br>
                <label class="radio-inline"><input type="radio" name="radioTipoDesc" v-model="tipo_desc" value="dinheiro" >Desconto em dinheiro</label>
              </div>
              <div v-show="tipo_desc != 'frete'" class="row">
                <div class="col-sm-4">
                  <h4>Desconto</h4>
                  <input v-model="desconto" type="number" class="form-control">
                  <label v-if="desconto ===''">*Campo Obrigatório</label>
                </div>
              </div>
            </div><br>
            <div class="row">
              <div class="col-md-1">
                <h4>Ativo</h4>
                  <toggle-button 
                    v-model="ativo"
                    :color="color" 
                    :sync="true" />
              </div>
            </div><br>
          </tab-content>

          <el-button type="primary" class="btn btn-primary" slot="prev">Anterior</el-button>
          <el-button type="primary" class="btn btn-primary" slot="next">Próximo</el-button>
          <el-button v-show="!gravando" type="primary" class="btn btn-primary" slot="finish">Confirmar</el-button>
          <el-button v-show="gravando" type="primary" class="btn btn-primary" slot="finish" disabled><i
              class="fa fa-spinner fa-spin"></i>Confirmar</el-button>
        </form-wizard>


      </div>
    </box>

  </section>
</template>
<script>
  import Modal from '../Modal' // importando modal
  import Box from '../Box'
  import resource from './resource'
  import axios from 'axios'

  export default {
    name: 'Nova Campanha',
    components: {
      'modal': Modal,
      'box': Box,
    },
    data() {
      return {
        gameColor: 'white',
        ticketColor: 'white',
        // freteColor: 'white'
        selecionado: '',
        tipo_desc: 'frete',
        codigo: '',
        qtde_cupom: 0,
        validade: null,
        desconto: 0,
        ativo: true,
        gravando: false,
        alteracao: false,
        id_alteracao: null
      }
    },
    computed: {
    },
    created() {
      if(this.$route.params.id) {
        this.alteracao = true
        this.id_alteracao = this.$route.params.id
        this.getCampanha(this.id_alteracao)
      }
    },
    methods: {
      getCampanha(id) {
        this.selecionarCard('ticket');
        resource.getCampanhaByID(id).then(res => {
          let data = res.data;
          console.log('campanha => ', data);
          this.ativo = data.ativo;
          this.tipo_desc = data.frete_gratis ? 'frete' : (data.porcentagem_desconto > 0 ? 'porcentagem' : 'dinheiro')
          this.codigo = data.codigo;
          this.qtde_cupom = data.qtde_permitida;
          this.desconto = data.porcentagem_desconto > 0 ? data.porcentagem_desconto : data.dinheiro_desconto;
          
          let novaData = new Date(data.data_validade)
          let dia = novaData.getDate()
          let mes = novaData.getMonth() + 1
          let ano = novaData.getFullYear()
          let hr = novaData.getHours().toString()
          let min = novaData.getMinutes().toString()
          this.validade = ano + '-' + mes + '-' + dia + 'T' + (hr.length === 1 ? '0' + hr : hr) + ':' + (min.length === 1 ? '0' + min : min)
          console.log('nova data => ', this.validade)
        });
      },
      selecionarCard (tipo) {
        this.selecionado = tipo;
        switch (tipo) {
          case 'game':
            this.gameColor = 'fundoAzul';
            this.ticketColor = 'white';
            this.freteColor = 'white';
            break;
          case 'ticket':
            this.gameColor = 'white';
            this.ticketColor = 'fundoAzul';
            this.freteColor = 'white';
            break;
          default:
            break;
        }
      },
      validateFirstStep() {
        if(this.selecionado) return true
      },
      onComplete () {
        console.log('data => ', this.validade)
        let data = new Date(this.validade).toLocaleString("en-GB", {timeZone: 'Europe/London'});
        let novaData = `${(data.split(',')[0]).split('/')[2]}-${(data.split(',')[0]).split('/')[1]}-${(data.split(',')[0]).split('/')[0]}T${(data.split(',')[1])}`
        console.log('nova data => ', novaData)
        this.gravando = true
        if(this.codigo && this.qtde_cupom && this.validade && (this.tipo_desc != 'frete' && this.desconto > 0 || this.tipo_desc === 'frete')) {
          let obj = {
            codigo: this.codigo,
            qtde_permitida: this.qtde_cupom,
            data_validade: novaData.replace(' ', ''),
            frete_gratis: this.tipo_desc === 'frete',
            dinheiro_desconto: this.tipo_desc === 'dinheiro' ? this.desconto : 0,
            porcentagem_desconto: this.tipo_desc === 'porcentagem' ? this.desconto : 0,
            ativo: this.ativo,
            empresa: this.$store.state.empresa_fb_id
          }
          if(!this.alteracao) {
            resource.gravarCampanha(obj).then(res => {
              this.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Gravado com sucesso',
                showConfirmButton: false,
                timer: 1500
              })
              this.$swal({
                title: 'Notificar Clientes',
                html: 'Deseja notificar os clientes sobre o novo cupom?',
                type: 'success',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Cancelar',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Notificar'
              }).then((result) => {
                if (result.value) {
                  axios.get(`${this.$store.state.api}clientes?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
                    console.log('clientes ==> ', response.data)
                    this.$router.push({ name: 'NotificarClientes', params: { clientes: response.data, cupom: this.codigo, tipo: this.tipo_desc, desconto: this.desconto }})
                  })
                } else {
                  this.$router.go(-1)
                }
              })
            }).catch(err => {
              this.$swal(
                'Ops!',
                'Ocorreu um erro na gravação da campanha.',
                'error'
              )
              this.gravando = false
            })
          } else {
            resource.updateCampanha(obj, this.id_alteracao).then(res => {
              this.$swal({
                position: 'top-end',
                type: 'success',
                title: 'Gravado com sucesso',
                showConfirmButton: false,
                timer: 1500
              })
              this.$router.go(-1)
            }).catch(err => {
              this.$swal(
                'Ops!',
                'Ocorreu um erro na gravação da campanha.',
                'error'
              )
              this.gravando = false
            })
          }
        } else {
          this.$swal(
            'Ops!',
            'Por favor, preencha todos os campos.',
            'error'
          )
          this.gravando = false
        }
      }
    }
  }

</script>
<style scoped> 
.infoBox {
  border: 1px solid #21A0FF;
  width: 100%;    
  border-top-left-radius: 2px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 2px;
  display: block;
  float: left;
  /* height: 90px; */
  text-align: center;
  font-size: 45px;
  line-height: 90px;
  cursor: pointer;
}
.iconBox{
  color: #3C8DBC
}
.white{
  background-color: white;
}
.fundoAzul {
  background-color: #21A0FF
}
.iconwhite {
  color: #3C8DBC
}
.iconfundoAzul {
  color: white
}
.lblCard {
  font-weight: bold
}
.lblwhite {
  color: #3C8DBC
}
.lblfundoAzul {
  color: white
}
</style>



// WEBPACK FOOTER //
// novaCampanha.vue?21632960